// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3J3wQ","choiceBoxes":"toolbarselects_choiceBoxes__HIx0N","simpleField":"toolbarselects_simpleField__28dCt"};